module.exports = __webpack_public_path__ + "img/commercial_06_reports.d11406c5.svg";